import { createTheme, Theme } from "@mui/material";
import {
  StyledButtons,
  StyledCheckBox,
  StyledDialog,
  StyledRadio,
  StyledTab,
  StyledTabs,
  StyledTextField,
} from "./styles";

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}

const asonikaTheme = createTheme({
  components: {
    MuiButton: StyledButtons,
    MuiCheckbox: StyledCheckBox,
    MuiDialog: StyledDialog,
    MuiRadio: StyledRadio,
    MuiTab: StyledTab,
    MuiTabs: StyledTabs,
    MuiTextField: StyledTextField,
  },
});

//TODO: Сделать HOC с ThemeProvider
export default asonikaTheme;
